import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { Watch } from "react-loader-spinner";

const AddSeries = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [userDrp, setUserDrpData] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formValue, setFormValue] = useState({
    id: "",
    name: "",
    user_id: "",
    surface: "",
  });

  const saveSeries = () => {
    if (formValue.name && formValue.user_id && formValue.surface) {
      setError(false);
      setLoading(true);
      var formData = new FormData();
      formData.append("name", formValue.name);
      formData.append("id", formValue.id);
      formData.append("user_id", formValue.user_id);
      formData.append("surface", formValue.surface);
      const pUrl = id ? API_URL.SERIES_UPDATE : API_URL.SERIES_SAVE;
      axios
        .post(pUrl, formData)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            if (id) {
              toast.success("Updated", {
                autoClose: 3000,
                position: "top-center",
              });
              setTimeout(() => {
                navigate("/admin/series", { replace: true });
              }, 100);
            } else {
              setTimeout(() => {
                navigate("/admin/series", { replace: true });
              }, 100);
              toast.success("Saved", {
                autoClose: 3000,
                position: "top-center",
              });
            }
          } else {
            toast.error(res.data.data, {
              autoClose: 3000,
              position: "top-center",
            });
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setError(true);
      toast.error("Please enter valid details", {
        autoClose: 3000,
        position: "top-center",
      });
    }
  };

  const isShowError = (value) => {
    if (
      isError &&
      (!value || value == "" || value == null || value == undefined)
    ) {
      return true;
    }
    return false;
  };

  const getUser = () => {
    axios.post(API_URL.USER_LIST, {}).then((res) => {
      let cd = res.data.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setUserDrpData(cd);
    });
  };

  const onEdit = () => {
    axios.post(API_URL.SERIES_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          user_id: res.data.data.user_id ? res.data.data.user_id : "",
          surface: res.data.data.surface ? res.data.data.surface : "",
        });
      }
    });
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (!res.data.is_allowed) {
          if (id) {
            onEdit();
          } else {
            setFormValue({ ...formValue, user_id: res.data.id });
          }
        } else {
          getUser();
          if (id) {
            onEdit();
          }
        }
      }
    });
  };

  useEffect(() => {
    userInfo();
  }, []);

  const getInputStyles = (isError) => ({
    borderColor: isError ? "red" : undefined,
  });
  
  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Tiles Series</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/series"} className="btn btn-sm btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form
            onSubmit={(event) => event.preventDefault()}
            encType="multipart/form-data"
          >
            <div className="row">
              {isAllowed && (
                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.user_id) && "required-field"
                      }`}
                    >
                      Client<span className="required-star">*</span>
                    </label>
                    <Select
                      options={userDrp}
                      value={userDrp.find((r) => r.value === formValue.user_id)}
                      styles={{
                        ...styles,
                        control: (base) => ({
                          ...base,
                          borderColor: isShowError(formValue.user_id)
                            ? "red"
                            : base.borderColor,
                        }),
                      }}
                      onChange={(e) => {
                        setFormValue({ ...formValue, user_id: e.value });
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.name) && "required-field"
                    }`}
                  >
                    Tiles Series Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formValue.name}
                    className="form-control"
                    placeholder="Ex. Glosyy"
                    style={getInputStyles(isShowError(formValue.name))}
                    id="name"
                    onChange={(event) => {
                      setFormValue({ ...formValue, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.surface) && "required-field"
                    }`}
                  >
                    Tiles Surface Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="surface"
                    value={formValue.surface}
                    placeholder="Ex. Matt"
                    className="form-control"
                    style={getInputStyles(isShowError(formValue.surface))}
                    id="surface"
                    onChange={(event) => {
                      setFormValue({
                        ...formValue,
                        surface: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-end">
                <button
                  type="submit"
                  onClick={saveSeries}
                  disabled={loading}
                  className="btn btn-sm btn-primary"
                >
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Watch color={"white"} height={20} width={20} />
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSeries;
